import * as React from "react";
const SvgCheckboxChecked = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path fill="#826846" d="M1 9a8 8 0 0 1 8-8h6a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H9a8 8 0 0 1-8-8z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.54 11.904a.65.65 0 0 1 .92 0l3.008 3.01 5.977-5.843a.65.65 0 0 1 .909.93l-6.436 6.291a.65.65 0 0 1-.914-.005L6.54 12.824a.65.65 0 0 1 0-.92"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxChecked;
